import { defineMessages } from 'react-intl-next';

export const messages: {
	jira_quick_find_single_site_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jira_quick_find_projects: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jira_quick_find_spaces: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jira_quick_find_boards: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jira_quick_find_filters: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jira_quick_find_plans: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jira_quick_find_people: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jira_quick_find_work_items: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	jira_quick_find_single_site_label: {
		id: 'jira_single_site_label',
		defaultMessage: 'Go to all:',
		description:
			'Label for when the user wants to navigate to a single site on Jira via the search query',
	},
	jira_quick_find_projects: {
		id: 'jira_single_site_projects',
		defaultMessage: 'Projects',
		description: 'Plural of project',
	},
	jira_quick_find_spaces: {
		id: 'jira_single_site_spaces',
		defaultMessage: 'Spaces',
		description: 'Plural of space',
	},
	jira_quick_find_boards: {
		id: 'jira_single_site_boards',
		defaultMessage: 'Boards',
		description: 'Plural of board',
	},
	jira_quick_find_filters: {
		id: 'jira_single_site_filters',
		defaultMessage: 'Filters',
		description: 'Plural of filter',
	},
	jira_quick_find_plans: {
		id: 'jira_single_site_plans',
		defaultMessage: 'Plans',
		description: 'Plural of plan',
	},
	jira_quick_find_people: {
		id: 'jira_single_site_people',
		defaultMessage: 'Teams',
		description: 'Used in Jira to refer to people',
	},
	jira_quick_find_work_items: {
		id: 'jira_single_site_work_items',
		defaultMessage: 'Work items',
		description: 'Label for the Work items navigation button in Jira single site search',
	},
});
